export default __webpack_public_path__ + "static/media/lucky-tnc-cn.51c6c301.svg";